import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=393c20d0&scoped=true&"
import script from "./FormError.vue?vue&type=script&lang=js&"
export * from "./FormError.vue?vue&type=script&lang=js&"
import style0 from "./FormError.vue?vue&type=style&index=0&id=393c20d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393c20d0",
  null
  
)

export default component.exports